// import React, { useContext } from 'react'
import React from 'react'
import { Columns, Column } from 'bloomer'
import styled from 'styled-components'
import Link from './link'
// import { ScheduleModalContext } from './schedule'

// const ScheduleLink = styled.button`
//   background-color: #363636;
//   align-items: center;
//   border: none;
//   border-radius: 4px;
//   box-shadow: none;
//   color: white !important;
//   cursor: pointer;
//   display: inline-flex;
//   font-size: 1rem;
//   height: 2.5rem;
//   justify-content: center;
//   line-height: 1.5;
//   outline: none;
//   padding-bottom: calc(0.375rem - 1px);
//   padding-left: 0.75rem;
//   padding-right: 0.75rem;
//   padding-top: calc(0.375rem - 1px);
//   position: relative;
//   text-align: center;
//   transition: transform 0.4s ease;
//   user-select: none;
//   vertical-align: top;
//   white-space: nowrap;
//   width: 144px;

//   :active,
//   :focus,
//   :hover {
//     background-color: #2f2f2f;
//     color: white !important;
//     transform: translateY(-4px);
//   }

//   @media only screen and (min-width: 45rem) {
//     font-size: 1.25rem;
//     height: 3rem;
//     padding: 1rem;
//     width: 12rem;
//   }
// `

// const Schedule = ({ style }) => {
//   const { trigger } = useContext(ScheduleModalContext)

//   return (
//     <ScheduleLink onClick={trigger} style={style}>
//       Schedule Demo
//     </ScheduleLink>
//   )
// }

// const CallsToActionWithDemo = ({ className, columns, freeTrialStyle, isGapless, isGrid, scheduleDemoStyle, style }) => {
//   let ctas = (
//     <>
//       <FreeTrial style={freeTrialStyle || defaultFreeTrialStyle} />
//       <Schedule style={scheduleDemoStyle || defaultScheduleDemoStyle} />
//     </>
//   )

//   if (columns || columns === 'undefined') {
//     ctas = (
//       <Columns
//         className={className}
//         isGapless={isGapless || false}
//         isGrid={isGrid || true}
//         style={style}
//         isCentered
//         isVCentered
//       >
//         <Column isSize={{ default: 6 }} style={freeTrialStyle}>
//           <FreeTrial />
//         </Column>
//         <Column isSize={{ default: 6 }} style={scheduleDemoStyle}>
//           <Schedule />
//         </Column>
//       </Columns>
//     )
//   }

//   return ctas
// }

const FreeTrialLink = styled(Link)`
  background-color: #0b64e9;
  align-items: center;
  border-radius: 4px;
  box-shadow: none;
  color: white !important;
  cursor: pointer;
  display: inline-flex;
  font-size: 1rem;
  height: 2.5rem;
  justify-content: center;
  line-height: 1.5;
  padding-bottom: calc(0.375rem - 1px);
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  padding-top: calc(0.375rem - 1px);
  position: relative;
  text-align: center;
  transition: transform 0.4s ease;
  user-select: none;
  vertical-align: top;
  white-space: nowrap;
  width: 144px;

  :active,
  :focus,
  :hover {
    background-color: #0061e4;
    color: white !important;
    transform: translateY(-4px);
  }

  @media only screen and (min-width: 45rem) {
    font-size: 1.25rem;
    height: 3rem;
    padding: 1rem;
    width: 12rem;
  }
`

const FreeTrial = ({ style, link, label }) => (
  <FreeTrialLink to={link || "/questionnaire"} rel="noopener noreferrer" style={style} target="_blank">
    {label || 'Sign Up'}
  </FreeTrialLink>
)

const defaultFreeTrialStyle = { marginTop: '1.5rem', marginRight: '0.5rem' }
const defaultScheduleDemoStyle = { marginTop: '1.5rem', marginLeft: '0.5rem' }

const CallsToAction = ({
  columns,
  freeTrialStyle = defaultFreeTrialStyle,
  scheduleDemoStyle = defaultScheduleDemoStyle,
  isCentered = true,
  isGapless = false,
  isGrid = true,
  isVCentered = true,
  link,
  label,
  ...props
}) => {
  let ctas = <FreeTrial style={freeTrialStyle} link={link} label={label} />

  if (columns || columns === 'undefined') {
    ctas = (
      <Columns isGapless={isGapless} isGrid={isGrid} isCentered={isCentered} isVCentered={isVCentered} {...props}>
        <Column style={freeTrialStyle}>
          <FreeTrial link={link} label={label} />
        </Column>
      </Columns>
    )
  }

  return ctas
}

export default CallsToAction
